export default {
  getQuotas(state) {
    return state.quotas;
  },
};
